var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"viewer",staticClass:"wh-full viewer"},[(_vm.loading)?_c('div',{staticClass:"viewer__loading"},[_vm._v(" Загрузка модели... ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }